import { createUsePermissions } from "./createUsePermissions";

export const useMenusPermissions = createUsePermissions("pb.menu");
